module.exports = __webpack_public_path__ + "static/media/main-bg.a4973c3e.jpg";